import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, ref } from "vue";
import store from "@/store";
import i18n from "@/plugins/vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolbarAdminLanguageDialog',
  setup(__props, { expose }) {

const instance = getCurrentInstance();
const dialog = ref(false);
const locale = ref("");

function open(_locale: string): void {
  dialog.value = true;
  locale.value = _locale;
}

function close(): void {
  dialog.value = false;
  locale.value = "";
}

function setLanguage(): void {
  if (locale.value) {
    i18n.locale = locale.value;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (instance) {
      instance.proxy.$vuetify.lang.current = locale.value;
    }
    store.commit("setAdminLanguage", locale.value ?? "ko");

    close();
    window.location.reload();
  }
}
expose({ open });

return { __sfc: true,instance, dialog, locale, open, close, setLanguage }
}

})